export default "__VITE_ASSET__27c13300__"